module.exports = __webpack_public_path__ + "static/media/cancel-outline-chip.58e2f6f0.svg";